module.exports = __webpack_public_path__ + "static/media/inspect_reversed_blue_circle_white_m.7d471333.png";